import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';
import styled from 'styled-components';
import colors from '../../config/colors';

const ButtonWrapper = styled(Flex)`

    @media screen and (max-width:  641px) {
        font-size: 0.7em;
    }

    background-color: ${colors.Black};
    color: ${colors.White};
    align-items: center;
    border-radius: 0.5em;
    border-style: solid;
    border-width: 0.1em;
    border-color: ${colors.LightGray};

    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;

    width: 16em;

    cursor: pointer;
`;

const StoreIcon = styled(Box)`
    padding: 1em;
`;

const TextSection = styled(Flex)`
    padding: 1em 1em 1em 0em;
    flex-direction: column
`;

const StoreName = styled(Box)`
    font-size: 2em;
`;

const StyledImg = styled.img`
    width: 2.5em;
    
`;

interface DownloadButtonIProps {
    imageURL: string,
    storeName: string,
    availablePhrase: string,
    targetURL: string,
}

interface DownloadButtonIState {

}

export default class DownloadButton extends Component<DownloadButtonIProps, DownloadButtonIState>{
    render() {
        const { imageURL, storeName, availablePhrase, targetURL } = this.props;

        return <ButtonWrapper onClick={() => window.open(targetURL)}>
            <StoreIcon>
                <StyledImg src={imageURL} />
            </StoreIcon>
            <TextSection>
                <Box>
                    {availablePhrase}
                </Box>
                <StoreName>
                    {storeName}
                </StoreName>
            </TextSection>
        </ButtonWrapper >
    }
}
